import { OrganizationPermissions, TypologiesEnum, UsersPermissions } from '@quadminds/shared/auth-system';

/**
 * Param types
 */
export type OrganizationIdQueryParams = { organizationId: string };
export type InviteUuidQueryParams = { uuid: string };

/**
 * Response types
 */
export type CheckInviteResponse = {
    organization: OrganizationResponse;
    expiresAt: string;
    email: string;
    userExternalId?: string;
};

export type CheckUserExistenceResponse = {
    exists: boolean;
};

export type OrganizationResponse = {
    id: string;
    name: string;
    locale: string;
};

export type Typologies = {
    name: string;
    code: TypologiesEnum;
};

export type Permissions = {
    name: string;
    code: UsersPermissions | OrganizationPermissions;
};

export type User = {
    _id: string;
    address: string;
    avatar: string;
    currentOrganization: string;
    email: string;
    externalId: string;
    firstName: string;
    lastName: string;
    phone: string;
};

export interface IUserSettingsOutputDto {
    user: string;
    settings: Record<string, unknown>;
}

export interface IUserSelfSettingsOutputDto {
    id?: string;
    user: string;
    rootSettings: Record<string, unknown>;
    organizationSettings: Record<string, unknown>;
    currentOrganization: string;
}
